// import React, { useEffect, useRef, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
// import 'react-toastify/dist/ReactToastify.css';

// function ContactUs() {
//   const location = useLocation();
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     description: '',
//   });
//   const [errors, setErrors] = useState({});
//   const formRef = useRef();

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//     setErrors((prevErrors) => ({ ...prevErrors, [id]: '' }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     // Validate fields
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = 'Name is required';
//     if (!formData.email.trim()) newErrors.email = 'Email is required';
//     if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
//     if (!formData.description.trim()) newErrors.description = 'Message is required';
  
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       toast.error('Please fill out all required fields!');
//       return;
//     }
  
//     try {
//       const response = await fetch('http://localhost:5000/contact', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData),
//       });
  
//       if (!response.ok) throw new Error('Failed to send message');
  
//       toast.success('Message sent successfully!');
//       setFormData({ name: '', email: '', phone: '', description: '' });
//     } catch (error) {
//       toast.error('Error sending message. Please try again later.');
//       console.error('Error:', error);
//     }
//   };
  

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location.pathname]);

//   return (
//     <div className="bg-black min-h-screen">
//       <ToastContainer />
//       <div className="relative bg-cover bg-center h-[400px] md:h-[500px]" style={{ backgroundImage: "url('images/landin3.jpeg')" }}>
//         <div className="absolute inset-0 bg-black opacity-70"></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
//           <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Contact Us</h1>
//           <p className="mt-2 text-base md:text-lg text-zinc-300">DSGO solutions tailored to your needs.</p>
//         </div>
//       </div>

//       <div className="flex flex-col md:flex-row lg:p-20 gap-10">
//         <div className="w-full lg:w-1/2 flex justify-center items-center p-4">
//           <div className="bg-white bg-opacity-10 backdrop-blur-md p-6 md:p-8 rounded-lg shadow-lg max-w-xl w-full">
//             <h2 className="text-center text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-white">Send a Message</h2>
//             <form ref={formRef} className="space-y-8 md:space-y-12" onSubmit={handleSubmit}>
//               {['name', 'phone', 'email', 'description'].map((field, index) => (
//                 <div key={index}>
//                   {field !== 'description' ? (
//                     <input
//                       type={field === 'email' ? 'email' : 'text'}
//                       id={field}
//                       placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
//                     />
//                   ) : (
//                     <textarea
//                       id={field}
//                       placeholder="Message"
//                       value={formData[field]}
//                       onChange={handleChange}
//                       className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
//                       rows="4"
//                     ></textarea>
//                   )}
//                   {errors[field] && <p className="text-red-500 text-sm mt-1">{errors[field]}</p>}
//                 </div>
//               ))}
//               <button type="submit" className="w-full py-2 mt-4 border border-zinc-500 rounded-3xl text-white font-semibold hover:bg-zinc-800 transition">
//                 Submit
//               </button>
//             </form>
//           </div>
//         </div>

//         <div className="w-full lg:w-1/2 flex flex-col items-center text-white justify-center p-4 space-y-8 mb-20 md:mb-0">
//           <p className="text-center text-base lg:text-lg max-w-lg">
//             We’d love to hear from you! Get in touch with us for any queries related to our services.
//           </p>
//           <div className="flex justify-center gap-8 md:gap-10">
//             {[{ icon: FaPhone, text: '+0123456789' }, { icon: FaEnvelope, text: 'info@dsgosolutions.com' }, { icon: FaWhatsapp, text: '+0987654321' }, { icon: FaMapMarkerAlt, text: '26 Skylines Village Canada E14 9TS' }].map(({ icon: Icon, text }, idx) => (
//               <div key={idx} className="flex flex-col items-center text-center space-y-2">
//                 <Icon className="text-2xl md:text-3xl text-primary" />
//                 <span className="text-sm md:text-base">{text}</span>
//               </div>
//             ))}
//           </div>
//           <div className="pt-12 brightness-75">
//             <iframe
//               title="Canada Location Map"
//               src="https://www.google.com/maps/embed?..."
//               className="xl:w-[600px] h-64 rounded-lg"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             ></iframe>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactUs;




import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import emailjs from 'emailjs-com';  // For email sending functionality
import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';  // For icons

function ContactUs() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: '',
  });

  const [errors, setErrors] = useState({});
  const formRef = useRef();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    // Clear the error for the current field
    setErrors((prevErrors) => ({ ...prevErrors, [id]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate fields
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.description.trim()) newErrors.description = 'Message is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fill out all required fields!');
      return;
    }

    // Send email using emailjs
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          from_phone: formData.phone,
          from_message: formData.description,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log('Success:', result.text);
          toast.success('Message sent successfully!');
          setFormData({ name: '', email: '', phone: '', description: '' });
        },
        (error) => {
          console.error('Error:', error.text);
          toast.error('Error sending message!');
        }
      );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="bg-black min-h-screen">
      <ToastContainer /> {/* Toastify Container */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[500px]"
        style={{ backgroundImage: "url('images/landin3.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black opacity-70"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Contact Us</h1>
          <p className="mt-2 text-base md:text-lg text-zinc-300">
            DSGO  solutions tailored to your needs.
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row lg:p-20 gap-10">
        {/* Send a Message Section */}
        <div className="w-full lg:w-1/2 flex justify-center items-center p-4">
          <div className="bg-white bg-opacity-10 backdrop-blur-md p-6 md:p-8 rounded-lg shadow-lg max-w-xl w-full">
            <h2 className="text-center text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-white">Send a Message</h2>
            <form ref={formRef} className="space-y-8 md:space-y-12" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  id="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
              </div>
              <div>
                <input
                  type="text"
                  id="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
              <div>
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>
              <div>
                <textarea
                  id="description"
                  placeholder="Message"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-white bg-transparent text-white placeholder-white rounded"
                  rows="4"
                ></textarea>
                {errors.description && <p className="text-red-500 text-sm mt-1">{errors.description}</p>}
              </div>
              <button
                type="submit"
                className="w-full py-2 mt-4 border border-zinc-500 rounded-3xl text-white font-semibold hover:bg-zinc-800 transition"
              >
                Submit
              </button>
            </form>
          </div>
        </div>

       {/* Contact Info Section */}
 <div className="w-full lg:w-1/2 flex flex-col items-center  text-white justify-center p-4 space-y-8 mb-20 md:mb-0">
 <p className="text-center text-base lg:text-lg max-w-lg">
   We’d love to hear from you! Get in touch with us for any queries related to our services.
   Our team is here to provide assistance and answer any questions you may have.
 </p>

 <div className="flex justify-center gap-8 md:gap-10">
   <div className="flex flex-col items-center text-center gap-4">
     <div className="flex flex-col items-center text-center space-y-2">
       <FaPhone className="text-2xl md:text-3xl text-primary" />
    <span className="text-sm md:text-base">+1 647 468 7434</span>

     </div>
     <div className="flex flex-col items-center text-center space-y-2">
       <FaEnvelope className="text-2xl md:text-3xl text-primary" />
       <span className="text-sm md:text-base">FGomes@dsgo.ca</span>
     </div>
   </div>

   <div className="flex flex-col items-center text-center gap-4">
     <div className="flex flex-col items-center text-center space-y-2">
       <FaWhatsapp className="text-2xl md:text-3xl text-primary" />
       <span className="text-sm md:text-base">+1 647 468 7434</span>
     </div>
     <div className="flex flex-col items-center text-center space-y-2">
       <FaMapMarkerAlt className="text-2xl md:text-3xl text-primary" />
       <span className="text-sm md:text-base">Woodbridge, ON, L4L5W5</span>
     </div>
   </div>
 </div>
<div className="pt-12 brightness-75">
  <iframe
    title="Woodbridge, ON L4L 5W5 - Map"
    src="https://www.google.com/maps?q=Woodbridge+ON+L4L+5W5&output=embed"
    className="xl:w-[600px] h-64 rounded-lg"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>


</div>

      </div>
    </div>
  );
}

export default ContactUs

